/**
 * Company settings data access (issue #23).
 *
 * Mirrors go-service/internal/api/company_settings.go: GET/PUT
 * /api/admin/company-settings. The PUT is partial — only supplied keys are
 * written — so each settings section can save independently.
 */
import { resource } from "./resource";

export interface CompanySettings {
  name: string;
  contact_email: string;
  public_url: string;
  payment_account_name: string;
  payment_bank_name: string;
  payment_account_number: string;
  gst_number: string;
  nzbn: string;
  deposit_percent_default: number;
  quote_valid_days_default: number;
  multi_day_extra_day_percent: number;
  terms_url: string;
  payment_terms_text: string;
  /**
   * Document-wide values (#188 follow-on): the extra note renders on every
   * job sheet and quote; the contractor terms link on every job sheet.
   */
  extra_notes_text: string;
  contractor_terms_url: string;
  /**
   * Whether the quote Phase reserves Equipment stock (#314). Off by default:
   * quotes that never close would otherwise hold the catalogue.
   */
  quotes_hold_stock: boolean;
  logo_url: string;
}

/** Partial update — only supplied keys are written. */
export type CompanySettingsUpdate = Partial<CompanySettings>;

const settings = resource<CompanySettings>(
  "/api/admin/company-settings",
  "settings",
);

export const getCompanySettings = (
  signal?: AbortSignal,
): Promise<CompanySettings> => settings.get(signal);

export const saveCompanySettings = (
  payload: CompanySettingsUpdate,
): Promise<CompanySettings> => settings.put(payload);
